export const loadScripts = async () => {
    // Landing Page Risk Profile Block
    if (document.querySelector(".risk-profile")) {
        await import("../landing-pages/legacy-modules.js");
    }

    // Carousels
    if (document.querySelector(".slider-for") || document.querySelector('.compound-hero') || document.querySelector(".recommended-insights__list") || document.querySelector(".carousel-block__main--desktop") || document.querySelector(".fund-carousel-block__main--desktop") || document.querySelector(".carousel-wrapper__main--desktop") || document.querySelector(".more-from-category__main--desktop")) {
        await import("./carousels.js");
    };

    // Home Page Video Carousel
    if (document.querySelector(".homepage-video-carousel")) {
        await import("../override/homepage-video-slider.js");
    }

    // Landing Page Carousels
    if (document.querySelector(".carousel-block__main--desktop-ucits")) {
        await import("./carousels.js");
        await import("../landing-pages/carousels.js");
    }

    // Video Carousels
    if (document.querySelector(".video-carousel")) {
        await import("./carousels.js");
        await import("../override/video-carousel.js");
    }

    // Related Media Grids
    if (document.querySelector(".ve-dynamic-related-media")) {
        await import("../../../../us/js/src/insights/related-media.js");
    }

    // Minimal Slick Slider
    if (document.querySelector("#minimalSlickSlider")) {
        await import("../override/minimal-slick-slider.js");
    }
};

export const loadDelayedScripts = async () => {
    // Performance Charts (highcharts)
    if (document.querySelector(".performance-chart-block-js")) {
        await import("./performance-charts.js");
    }

    // Highcharts Block
    if (document.querySelector(".highcharts-block-js")) {
        await import("../../../../us/js/src/highcharts-block.js");
    }
};